/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgentActivityHeatmapResponse } from '../models/AgentActivityHeatmapResponse';
import type { AgentActivityStatusFilter } from '../models/AgentActivityStatusFilter';
import type { AgentRow } from '../models/AgentRow';
import type { AgentSessionsResponse } from '../models/AgentSessionsResponse';
import type { AgentsResponse } from '../models/AgentsResponse';
import type { GatewayClientsResponse } from '../models/GatewayClientsResponse';
import type { PaginatedResponse_list_AgentActivityCall__ } from '../models/PaginatedResponse_list_AgentActivityCall__';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AgentsService {
    /**
     * List the current user's governed AI agents
     * @param pageSize
     * @param pageToken
     * @param userSession
     * @returns AgentsResponse Successful Response
     * @throws ApiError
     */
    public static listMyGovernedAgents(
        pageSize: number = 50,
        pageToken: string = '',
        userSession?: (string | null),
    ): CancelablePromise<AgentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/agents',
            cookies: {
                'user_session': userSession,
            },
            query: {
                'page_size': pageSize,
                'page_token': pageToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Client types an admin has set up against the tenant's gateway
     * @param userSession
     * @returns GatewayClientsResponse Successful Response
     * @throws ApiError
     */
    public static listGatewayClientTypes(
        userSession?: (string | null),
    ): CancelablePromise<GatewayClientsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/agents/gateway-clients',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get the current user's agent tool activity grouped by tool
     * @param agentId
     * @param status
     * @param skip
     * @param limit
     * @param userSession
     * @returns PaginatedResponse_list_AgentActivityCall__ Successful Response
     * @throws ApiError
     */
    public static getMyAgentActivity(
        agentId: string,
        status?: (AgentActivityStatusFilter | null),
        skip?: number,
        limit: number = 100,
        userSession?: (string | null),
    ): CancelablePromise<PaginatedResponse_list_AgentActivityCall__> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/agents/{agent_id}/activity',
            path: {
                'agent_id': agentId,
            },
            cookies: {
                'user_session': userSession,
            },
            query: {
                'status': status,
                'skip': skip,
                'limit': limit,
            },
            errors: {
                404: `agent not owned by caller`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get daily tool-call counts per app for one of the current user's agents
     * @param agentId
     * @param userSession
     * @returns AgentActivityHeatmapResponse Successful Response
     * @throws ApiError
     */
    public static getMyAgentActivityHeatmap(
        agentId: string,
        userSession?: (string | null),
    ): CancelablePromise<AgentActivityHeatmapResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/agents/{agent_id}/activity/heatmap',
            path: {
                'agent_id': agentId,
            },
            cookies: {
                'user_session': userSession,
            },
            errors: {
                404: `agent not owned by caller`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * List the OAuth sessions of one of the current user's agents
     * @param agentId
     * @param pageSize
     * @param pageToken
     * @param userSession
     * @returns AgentSessionsResponse Successful Response
     * @throws ApiError
     */
    public static listMyAgentSessions(
        agentId: string,
        pageSize: number = 50,
        pageToken: string = '',
        userSession?: (string | null),
    ): CancelablePromise<AgentSessionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/agents/{agent_id}/sessions',
            path: {
                'agent_id': agentId,
            },
            cookies: {
                'user_session': userSession,
            },
            query: {
                'page_size': pageSize,
                'page_token': pageToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke one of the current user's agents
     * @param agentId
     * @param userSession
     * @returns AgentRow Successful Response
     * @throws ApiError
     */
    public static revokeMyGovernedAgent(
        agentId: string,
        userSession?: (string | null),
    ): CancelablePromise<AgentRow> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/agents/{agent_id}',
            path: {
                'agent_id': agentId,
            },
            cookies: {
                'user_session': userSession,
            },
            errors: {
                404: `agent missing or owned by another user`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke one OAuth session of one of the current user's agents
     * @param agentId
     * @param familyId
     * @param userSession
     * @returns void
     * @throws ApiError
     */
    public static revokeMyAgentSession(
        agentId: string,
        familyId: string,
        userSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/agents/{agent_id}/sessions/{family_id}',
            path: {
                'agent_id': agentId,
                'family_id': familyId,
            },
            cookies: {
                'user_session': userSession,
            },
            errors: {
                404: `session missing, already revoked, or not owned by this agent or user`,
                422: `Validation Error`,
            },
        });
    }
}
